<script lang="ts">
import { defineComponent } from "vue";
import AppModal from "@/components/AppModal.vue";
import { RootState } from "@/store/types";
import { useStore } from "@/store/hooks"; // Import the typed hook

export default defineComponent({
  setup() {
    const store = useStore();

    const close = () => {
      store.dispatch("ErrorModalStore/toggleErrorModal", {
        errorType: "parallelEditError",
      });
    };
    const isErrorModalVisible = (errorType: string): boolean => {
      const errorstore = store?.state
        ?.ErrorModalStore as RootState["ErrorModalStore"];
      return errorstore.showModal && errorstore.errorType === errorType;
    };
    return {
      store,
      close,
      isErrorModalVisible,
    };
  },
  components: { AppModal },
});
</script>
<template>
  <AppModal
    id="parallel-edit-modal"
    :visible="isErrorModalVisible('parallelEditError')"
    modalType="accept"
    cancelText="tour.accept"
    @hide-modal="close"
  >
    <!-- Modal body -->
    <div
      v-if="isErrorModalVisible('parallelEditError')"
      class="p-6 flex flex-col w-full"
      data-testid="test-cancel-tour"
    >
      <h2 class="font-bold">
        {{ $t("error_parallel_edits") }}
      </h2>
    </div>
  </AppModal>
</template>
